/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Scattered_TitleInputs */

const en_why_listening_scattered_title = /** @type {(inputs: Why_Listening_Scattered_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your reading is scattered across apps that never talk.`)
};

const es_why_listening_scattered_title = /** @type {(inputs: Why_Listening_Scattered_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu lectura está repartida entre apps que no se comunican.`)
};

/**
* | output |
* | --- |
* | "Your reading is scattered across apps that never talk." |
*
* @param {Why_Listening_Scattered_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_scattered_title = /** @type {((inputs?: Why_Listening_Scattered_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Scattered_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_scattered_title(inputs)
	return en_why_listening_scattered_title(inputs)
});